module.exports = __webpack_public_path__ + "assets/fonts/Roboto-Bold.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto/Roboto-Bold.woff2
// module id = 684
// module chunks = 0